import { find, omitBy, isNil, isEmpty } from 'lodash';
import moment from 'moment';
import bankList from 'Data/bank-list.json';
import paymentTypeList from 'Data/payment-type.json';

const response = (data: any) => {
  const { details, status, gateway_response } = data;
  let statusDescription = '', selectedBank: any = {};
  let paymentStatus = status === 'PAID' ? status : 'UNPAID';

  if (status) {
    switch(status) {
      case 'PAID': statusDescription = 'txt.paymentReceived'; break;
      case 'PENDING': statusDescription = 'txt.paymentPending'; break;
      case 'FAILED': statusDescription = 'txt.paymentFailed'; break;
      case 'ABORTED': statusDescription = 'txt.userAbortTransaction'; break;
      case 'INVALID': statusDescription = 'txt.paymentInvalidParameters'; break;
      case 'NOT_FOUND': statusDescription = 'txt.paymentRecordNotFound'; break;
      default: statusDescription = 'txt.paymentRecordNotFound'; break;
    }

    selectedBank = find(bankList, (o) => o.bank_id === gateway_response.bank)
  }

  let paymentType: string | undefined;
  if (gateway_response?.Payment_ID) {
    paymentType = find(paymentTypeList, (elem) => elem.paymentID === gateway_response.Payment_ID)?.type;
  }

  return omitBy({
    transactionID: details.paymentGatewayOrderID,
    paymentDate: details.paymentDate ? moment.utc(details.paymentDate, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]') : null,
    paymentStatus: paymentStatus,
    paymentStatusDescription: statusDescription,
    bankID: selectedBank?.bank_id,
    bankName: selectedBank?.bank_name,
    paymentType: paymentType ?? gateway_response.payment_type,
    raw_error_description: gateway_response?.Error_Description ?? gateway_response?.raw_error_description,
    sourceType: gateway_response.source_type,
    shippingFees: details.shippingFee,
    subTotal: details.subTotal,
    total: details.total,
  }, isNil)
}

export default response;

// transactionID: details.paymentGatewayOrderID,
// paymentDate: details.paymentDate ? moment(details.paymentDate, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]') : null,
// paymentStatus: paymentStatus,
// paymentStatusDescription: statusDescription,
// bankID: selectedBank?.bank_id,
// bankName: selectedBank?.bank_name,
// paymentType: gateway_response.payment_type,
// raw_error_description: gateway_response.raw_error_description,
// sourceType: gateway_response.source_type,
// shippingFees: details.shippingFee,
// subTotal: details.subTotal,
// total: details.total,
// Bank_Code_Description
// Card_Type_Description
// Card_Category_Description